import { render, staticRenderFns } from "./Aixin.vue?vue&type=template&id=ea40c888&scoped=true&"
import script from "./Aixin.vue?vue&type=script&lang=js&"
export * from "./Aixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea40c888",
  null
  
)

export default component.exports